@if (!disabled) {
  <div class="phase-menu" [nbPopover]="popoverRef" nbPopoverPlacement="bottom">
    <nb-icon icon="more-vertical"></nb-icon>
  </div>
}
<ng-template #popoverRef>
  <nb-list>
    @for (m of filtered; track m; let i = $index) {
      <nb-list-item [class.disabled]="disabled || m.disabled"
        [class]="m.status ? 'status-' + m.status : null"
        (click)="clicked(m, i)">
        @if (m.icon) {
          <nb-icon [icon]="m.icon" [status]="m.status"></nb-icon>
        }
        <span>{{ m.title | translate:m.titlefill }}</span>
      </nb-list-item>
    }
  </nb-list>
</ng-template>
